import React from "react";
import { Box } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { CreateWOD } from "./CreateWOD";
import ViewWODs from "./ViewWODs";
import HistoryIcon from "@mui/icons-material/History";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

export const WOD = () => {
  const [tabItemValue, setTabItemValue] = React.useState(0);

  const onTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabItemValue(newValue);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        p: { xs: 2, md: 3 },
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Tabs
        value={tabItemValue}
        onChange={onTabChange}
        aria-label="workout tabs"
        sx={{
          flexShrink: 0,
          mb: 2,
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 600,
            fontSize: 14,
            minHeight: 44,
          },
          "& .MuiTabs-indicator": {
            height: 3,
            borderRadius: 1.5,
          },
        }}
      >
        <Tab
          icon={<HistoryIcon />}
          iconPosition="start"
          value={0}
          label="Past Workouts"
        />
        <Tab
          icon={<AddCircleOutlineIcon />}
          iconPosition="start"
          value={1}
          label="Create Workout"
        />
      </Tabs>
      <Box
        sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        {tabItemValue === 0 ? (
          <ViewWODs onEditWodSelected={() => setTabItemValue(1)} />
        ) : (
          <CreateWOD />
        )}
      </Box>
    </Box>
  );
};
